<template>
  <div v-if="!!phaseData">
    <v-sheet v-if="loading || error" class="d-flex flex-column align-center justify-center row-gap-2" height="50vh">
      <template v-if="error">
        <h3>Um erro ocorreu ao tentar carregar os dados da tela!</h3>
        <v-btn class="flex-grow-0" large color="primary" @click="loadData" :loading="loading"
          >tentar novamente <v-icon class="ml-2" large>mdi-refresh</v-icon></v-btn
        >
      </template>
      <template v-else>
        <h3>Carregando dados...</h3>
        <v-progress-circular indeterminate />
      </template>
    </v-sheet>
    <div v-else>
      <div v-if="!showForm">
        <v-btn
          block
          @click="!isFinishedAttendance ? (showForm = true) : (showForm = false)"
          :disabled="isFinishedAttendance"
        >
          <v-icon>mdi-plus</v-icon>
          Adicionar internação
        </v-btn>
      </div>
      <div v-else>
        <field-label label="Local da internação">
          <v-form ref="location">
            <div v-for="option in hospOptions.location" :key="option.key">
              <v-row>
                <v-col>
                  <v-col>
                    <v-checkbox
                      :value="option.key"
                      v-model="hospitalization.location[option.key].selected"
                      hide-details
                      :label="option.label"
                      class="pa-0 ma-0"
                    />
                  </v-col>
                  <v-col v-if="hospitalization.location[option.key].selected">
                    <field-label label="Tempo total da internação">
                      <v-row>
                        <v-col lg="3" md="12" sm="3">
                          <v-menu
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :value="
                                  hospitalization.location[option.key].time.start
                                    ? $moment(hospitalization.location[option.key].time.start).format('DD/MM/YYYY')
                                    : 'Data inicial'
                                "
                                solo
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <v-date-picker
                              v-model="hospitalization.location[option.key].time.start"
                              no-title
                              @change="hospitalization.location[option.key].time.end = null"
                              locale="pt-br"
                              :max="$moment().subtract(1, 'days').toISOString()"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col lg="3" md="12" sm="3">
                          <v-menu
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :value="
                                  hospitalization.location[option.key].time.end
                                    ? $moment(hospitalization.location[option.key].time.end).format('DD/MM/YYYY')
                                    : 'Data final'
                                "
                                solo
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <v-date-picker
                              v-model="hospitalization.location[option.key].time.end"
                              no-title
                              locale="pt-br"
                              :min="hospitalization.location[option.key].time.start"
                              :max="$moment().toISOString()"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </field-label>
                  </v-col>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </field-label>
        <field-label label="Motivo principal da internação">
          <v-form ref="reason">
            <v-row class="my-3">
              <v-col cols="6">
                <div v-for="option in hospOptions.reason" :key="option.key">
                  <v-checkbox
                    :value="option.key"
                    v-model="hospitalization.reason.selected"
                    hide-details
                    :label="option.label"
                    class="pa-0 ma-0"
                  />
                </div>
              </v-col>
              <v-col cols="6">
                <v-checkbox
                  value="outros"
                  v-model="hospitalization.reason.selected"
                  hide-details
                  label="Outros"
                  class="pa-0 ma-0"
                  @change="cleanTextArea('reason')"
                />
                <text-area
                  v-if="hospitalization.reason.selected.includes('outros')"
                  :max-length="2000"
                  v-model="hospitalization.reason.other"
                  :rules="rules.minlength"
                  :required="hospitalization.reason.selected.includes('outros')"
                />
              </v-col>
            </v-row>
          </v-form>
        </field-label>
        <field-label :label="'Tratamentos utilizados:'">
          <div v-for="key in sortedCategoryKeys" :key="`medicine-category-${key}`" class="mt-3">
            <v-expansion-panels accordion>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <v-row no-gutters>
                    <v-col cols="4">
                      {{ medicinesByCategory[key].category.name }}
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-checkbox
                    v-for="medicine in medicinesByCategory[key].medicines"
                    :key="medicine.id"
                    v-model="hospitalization.medicines"
                    :value="medicine.name"
                    :label="medicine.name"
                  />
                  <v-form class="mt-4" ref="addMedicineForm">
                    <div class="d-flex align-center gap-2" :class="{ 'flex-column': $vuetify.breakpoint.smAndDown }">
                      <text-field
                        class="flex-grow-1"
                        :label="`Adicionar novo medicamento do tipo ${medicinesByCategory[key].category.name} à lista`"
                        placehoder="Nome do medicamento"
                        :max-length="60"
                        :rules="rules.minlength"
                        v-model="newMedicineName"
                      />
                      <v-btn class="mt-1" outlined color="primary" small @click="addMedicine(key)">
                        adicionar medicamento<v-icon small class="ml-2">mdi-plus-circle-outline</v-icon>
                      </v-btn>
                    </div>
                  </v-form>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <v-row>
            <v-col cols="6">
              <v-checkbox
                label="Wet wrap/dress"
                v-model="hospitalization.wet_wrap.is_selected"
                @change="hospitalization.wet_wrap.value = null"
              />
              <text-field
                v-if="hospitalization.wet_wrap.is_selected"
                :required="hospitalization.wet_wrap.is_selected ? true : false"
                label="Descreva como foi utilizado"
                :placeholder="''"
                v-model="hospitalization.wet_wrap.value"
              /> </v-col
          ></v-row>
        </field-label>
        <field-label label="Outros eventos durante a internação" class="mt-6">
          <v-form ref="reason">
            <v-row class="my-3">
              <v-col cols="3">
                <div v-for="(option, index) in hospOptions.other_events" :key="option.key">
                  <v-checkbox
                    v-if="index <= 5"
                    :value="option.key"
                    v-model="hospitalization.other_events.selected"
                    hide-details
                    :label="option.label"
                    class="pa-0 ma-0"
                  />
                </div>
              </v-col>
              <v-col cols="3">
                <div v-for="(option, index) in hospOptions.other_events" :key="option.key">
                  <v-checkbox
                    v-if="index > 5"
                    :value="option.key"
                    v-model="hospitalization.other_events.selected"
                    hide-details
                    :label="option.label"
                    class="pa-0 ma-0"
                  />
                </div>
              </v-col>
              <v-col cols="6">
                <v-checkbox
                  value="outros"
                  v-model="hospitalization.other_events.selected"
                  hide-details
                  label="Outros"
                  class="pa-0 ma-0"
                  @change="cleanTextArea('other_events')"
                />
                <text-area
                  v-if="hospitalization.other_events.selected.includes('outros')"
                  :max-length="2000"
                  v-model="hospitalization.other_events.other"
                  :required="hospitalization.other_events.selected.includes('outros')"
                  :rules="rules.minlength"
                />
              </v-col>
            </v-row>
          </v-form>
        </field-label>
        <field-label label="Outras terapias">
          <text-area :readonly="disabled" :max-length="2000" v-model="hospitalization.other_therapies" />
        </field-label>
        <field-label label="Resumo">
          <text-area :readonly="disabled" :max-length="2000" v-model="hospitalization.summary" />
        </field-label>
        <div class="d-flex justify-end">
          <v-btn color="primary" @click="addHospitalization" :block="$vuetify.breakpoint.smAndDown ? true : false">
            {{ isEditing ? 'Salvar edição' : 'Adicionar internação' }}
          </v-btn>
        </div>
      </div>
      <field-label v-if="phaseData.hospitalizations.length > 0" label="Internações adicionadas:" class="mt-6">
        <div class="d-flex mt-3">
          <v-card
            :elevation="2"
            v-for="(hosp, index) in phaseData.hospitalizations"
            :key="index"
            :width="$vuetify.breakpoint.smAndDown ? '100%' : '25%'"
            :class="!$vuetify.breakpoint.smAndDown ? 'mr-6' : 'ma-0'"
            @click="openHospitalizationDialog(index)"
            :disabled="isEditing"
          >
            <v-card-title class="primary--text">
              {{ 'Internação #' + (index + 1) }}
            </v-card-title>
            <v-card-text> </v-card-text>
          </v-card>
        </div>
      </field-label>
      <field-label class="mt-8" label="Anotações">
        <text-area :readonly="disabled" :max-length="2000" v-model="phaseData.notes" :disabled="isFinishedAttendance" />
      </field-label>
    </div>
    <v-dialog
      v-if="phaseData.hospitalizations.length > 0"
      v-model="hospitalizationDialog"
      max-width="50%"
      :fullscreen="$vuetify.breakpoint.smAndDown ? true : false"
    >
      <v-card>
        <v-card-title class="primary--text">
          {{ 'Internação #' + (hospitalizationToShow + 1) }}
          <v-spacer />
          <v-btn fab small color="primary" @click="editHospitalization" :disabled="isFinishedAttendance">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-card-title>

        <field-label label="Local da internação">
          <v-chip v-for="(item, index) in locationsToShow(hospitalizationToShow)" :key="index" class="mr-3 mt-3">{{
            `${item.label}, ${item.time}`
          }}</v-chip>
        </field-label>
        <v-card-text>
          <field-label label="Motivo principal da internação" class="mt-6">
            <v-chip
              v-for="(item, index) in phaseData.hospitalizations[hospitalizationToShow].reason.selected"
              :key="index"
              class="mr-3 mt-3"
              >{{ item.charAt(0).toUpperCase() + item.slice(1).replaceAll('_', ' ') }}</v-chip
            >
          </field-label>
          <field-label
            v-if="phaseData.hospitalizations[hospitalizationToShow].reason.selected.includes('outros')"
            label="Outro:"
            class="mt-6"
          >
            <v-textarea
              height="fit-content"
              dense
              auto-grow
              readonly
              outlined
              rows="1"
              v-model="phaseData.hospitalizations[hospitalizationToShow].reason.other"
            />
          </field-label>
          <field-label label="Medicações utilizadas" class="mt-6">
            <v-chip
              v-for="(item, index) in phaseData.hospitalizations[hospitalizationToShow].medicines"
              :key="index"
              class="mr-3 mt-3"
              >{{ item.charAt(0).toUpperCase() + item.slice(1).replaceAll('_', ' ') }}</v-chip
            >
          </field-label>
          <field-label
            v-if="phaseData.hospitalizations[hospitalizationToShow].wet_wrap.is_selected"
            label="Uso do wet wrap/dress:"
            class="mt-6"
          >
            <v-text-field
              v-model="phaseData.hospitalizations[hospitalizationToShow].wet_wrap.value"
              readonly
              outlined
              class="mt-3"
            />
          </field-label>
          <field-label label="Outros eventos durante a internação" class="mt-6">
            <v-chip
              v-for="(item, index) in phaseData.hospitalizations[hospitalizationToShow].other_events.selected"
              :key="index"
              class="mr-3 mt-3"
              >{{ item.charAt(0).toUpperCase() + item.slice(1).replaceAll('_', ' ') }}</v-chip
            >
          </field-label>
          <field-label
            v-if="phaseData.hospitalizations[hospitalizationToShow].other_events.selected.includes('outros')"
            label="Outro:"
            class="mt-6"
          >
            <v-textarea
              height="fit-content"
              dense
              auto-grow
              readonly
              outlined
              rows="1"
              v-model="phaseData.hospitalizations[hospitalizationToShow].other_events.other"
            />
          </field-label>
          <field-label
            v-if="phaseData.hospitalizations[hospitalizationToShow].other_therapies"
            label="Outras terapias"
            class="mt-6"
          >
            <v-textarea
              height="fit-content"
              dense
              auto-grow
              readonly
              outlined
              rows="1"
              v-model="phaseData.hospitalizations[hospitalizationToShow].other_therapies"
            />
          </field-label>
          <field-label v-if="phaseData.hospitalizations[hospitalizationToShow].summary" label="Resumo" class="mt-6">
            <v-textarea
              height="fit-content"
              dense
              auto-grow
              readonly
              outlined
              rows="1"
              v-model="phaseData.hospitalizations[hospitalizationToShow].summary"
            />
          </field-label>
        </v-card-text>
        <v-card-actions class="justify-end px-8 pb-6">
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            small
            dense
            @click="deleteHospitalizationDialog = true"
            :disabled="isFinishedAttendance"
          >
            excluir
          </v-btn>
          <v-btn color="primary" text small dense @click="hospitalizationDialog = false"> fechar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteHospitalizationDialog" max-width="fit-content">
      <v-card>
        <v-card-title> Tem certeza? </v-card-title>
        <v-card-subtitle class="mt-3"> Excluir essa internação é irreversível. </v-card-subtitle>
        <v-card-actions>
          <v-spacer />
          <v-btn color="red" text small dense @click="deleteHospitalization(hospitalizationToShow)"> sim </v-btn>
          <v-btn color="primary" text small dense @click="deleteHospitalizationDialog = false"> cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { HOSPITALIZATION_OPTIONS } from '@/components/AttendanceForm/atopicdermatitis/constants/hospitalization.js'
import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'
import FieldLabel from '@/components/FieldLabel.vue'
import TextArea from '@/components/TextArea.vue'
import TextField from '@/components/TextField.vue'
import { MEDICINE_CATEGORIES } from '@/constants/medicine'

import { STATUS_FINISHED } from '@/constants/attendance'
import { v4 as uuidv4 } from 'uuid'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')

export default {
  components: { FieldLabel, TextArea, TextField },
  extends: BasePhase,
  data() {
    return {
      rules: {
        minlength: [(v) => (v && v.length >= 1) || 'O campo não pode estar vazio'],
      },
      resetting: false,
      deleteHospitalizationDialog: false,
      editHospitalizationDialog: false,
      isEditing: false,
      showForm: false,
      hospitalizationDialog: false,
      hospitalizationToShow: 0,
      loading: false,
      newMedicineName: null,
      error: false,
      medicines: [],
      hospOptions: HOSPITALIZATION_OPTIONS,
      hospitalization: {
        location: {
          uti: {
            selected: null,
            time: {
              start: null,
              end: null,
            },
          },
          enfermaria: {
            selected: null,
            time: {
              start: null,
              end: null,
            },
          },
          semi: {
            selected: null,
            time: {
              start: null,
              end: null,
            },
          },
        },
        time: {
          start: null,
          end: null,
        },
        reason: {
          selected: [],
          other: null,
        },
        medicines: [],
        wet_wrap: {
          is_selected: null,
          value: null,
        },
        other_events: {
          selected: [],
          other: null,
        },
        other_therapies: null,
        summary: null,
      },
    }
  },
  computed: {
    ...attendanceGettersMap(['attendanceDiseaseId']),
    ...attendanceGettersMap(['attendance']),

    isFinishedAttendance() {
      return this.attendance?.status === STATUS_FINISHED.value
    },
    medicinesByCategory() {
      const medicinesByCategory = {}
      for (const medicine of this.medicines[0]) {
        if (!medicinesByCategory[medicine.category.id]) {
          medicinesByCategory[medicine.category.id] = {
            category: medicine.category,
            medicines: [],
          }
        }

        medicinesByCategory[medicine.category.id].medicines.push(medicine)
      }
      return medicinesByCategory
    },
    sortedCategoryKeys() {
      const order = {}
      order[MEDICINE_CATEGORIES.TOPICOS] = 1
      order[MEDICINE_CATEGORIES.SISTEMICOS_TRADICIONAIS] = 2
      order[MEDICINE_CATEGORIES.IMUNOBIOLOGICOS] = 3
      return Object.entries(this.medicinesByCategory)
        .sort((entry1, entry2) => order[entry1[1].category.id] - order[entry2[1].category.id])
        .map((entry) => entry[0])
    },
  },
  methods: {
    getDefaultData() {
      const data = { hospitalizations: [] }
      return data
    },
    totalTime(location) {
      return this.$moment(location.time.end).diff(location.time.start, 'days')
    },
    addHospitalization() {
      const locationsToAdd = Object.values(this.hospitalization.location).filter((location) => location.selected)

      if (locationsToAdd.length < 0) {
        return this.$root.error('Local da internação é obrigatório')
      }

      if (locationsToAdd.some((location) => !location.time.start || !location.time.end)) {
        return this.$root.error(`Ambas datas devem estar selecionadas para cada local.`)
      }

      if (locationsToAdd.some((location) => this.totalTime(location) <= 0)) {
        return this.$root.error('O tempo total deve ser maior que um dia.')
      }

      if (!this.hospitalization.reason.selected.length > 0) {
        return this.$root.error('Motivo principal da internação é obrigatório')
      } else if (!this.isEditing) {
        this.phaseData.hospitalizations.push(this.hospitalization)
        this.resetHospitalization()
      } else {
        this.phaseData.hospitalizations.splice(this.hospitalizationToShow, 1, this.hospitalization)
        this.resetHospitalization()
        this.isEditing = false
      }
    },
    cleanTextArea(area) {
      if (!this.hospitalization[area].selected.includes('outros')) {
        this.hospitalization[area].other = null
      }
    },
    resetHospitalization() {
      this.resetting = true
      this.hospitalization = {
        location: {
          uti: {
            selected: null,
            time: {
              start: null,
              end: null,
            },
          },
          enfermaria: {
            selected: null,
            time: {
              start: null,
              end: null,
            },
          },
          semi: {
            selected: null,
            time: {
              start: null,
              end: null,
            },
          },
        },
        time: {
          start: null,
          end: null,
        },
        reason: {
          selected: [],
          other: null,
        },
        wet_wrap: {
          is_selected: null,
          value: null,
        },
        medicines: {
          antibiotics: [],
          topics: [],
          therapy: [],
        },
        other_events: {
          selected: [],
          other: null,
        },
        other_therapies: null,
        summary: null,
      }
    },
    async loadData() {
      try {
        this.loading = true
        const promises = await Promise.allSettled([this.$api.getMedicinesForDiseaseTreatment(this.attendanceDiseaseId)])
        const medicines = promises[0].value.items.filter((m) => m.category.id !== MEDICINE_CATEGORIES.FOTOTERAPICOS)
        this.medicines.push(medicines)
        this.error = false
      } catch (error) {
        this.$root.error(error)
        this.error = true
      } finally {
        this.loading = false
      }
    },
    addMedicine(categoryId) {
      if (this.$refs.addMedicineForm[0].validate()) {
        const id = uuidv4()
        const name = this.newMedicineName
        const category = this.$util.copy(this.medicinesByCategory[categoryId].category)

        this.medicines[0].push({
          id,
          name,
          category,
        })
        this.hospitalization.medicines.push(this.newMedicineName)
        this.newMedicineName = null
        this.$refs.addMedicineForm.forEach((form) => form.resetValidation())
      }
    },
    openHospitalizationDialog(index) {
      this.hospitalizationDialog = true
      this.hospitalizationToShow = index
    },
    confirmDeleteHospitalization() {
      this.deleteHospitalizationDialog = true
    },
    deleteHospitalization(id) {
      this.hospitalizationDialog = false
      this.deleteHospitalizationDialog = false
      if (
        this.hospitalizationDialog === false &&
        this.deleteHospitalizationDialog === false &&
        !this.isFinishedAttendance
      ) {
        this.phaseData.hospitalizations.splice(id, 1)
      } else {
        this.$root.error('Você não pode fazer isso agora')
      }
    },
    editHospitalization() {
      this.showForm = true
      this.hospitalizationDialog = false
      this.resetHospitalization()
      this.hospitalization = { ...this.phaseData.hospitalizations[this.hospitalizationToShow] }
      this.isEditing = true
    },
    locationsToShow(hospitalizationIndex) {
      return Object.values(this.phaseData.hospitalizations[hospitalizationIndex].location)
        .filter((location) => location.selected)
        .map((location) => ({
          label: HOSPITALIZATION_OPTIONS.location.find((loc) => loc.key === location.selected).label,
          time: this.getTimeString(location.time.start, location.time.end),
        }))
    },
    getTimeString(start, end) {
      const total = this.$moment(end).diff(start, 'days')
      let string = ''

      if (total > 8) {
        string = '>8 dias'
      } else if (total <= 3) {
        string = '1-3 dias'
      } else {
        string = '4-7 dias'
      }
      return string
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>
:deep(.v-input__prepend-outer) {
  margin-top: 4px !important;
}
:deep(.v-input__append-outer) {
  margin-top: 4px !important;
}
</style>
